import React, { useEffect, useState } from 'react';
import './NotificationPopup.css';

const NotificationPopup = ({ 
  message, 
  type = 'success', 
  onClose, 
  show, 
  redirectUrl = null, 
  showLoader = false, 
  autoClose = true,
  autoCloseDelay = 5000,
  customIcon = null,
  customButton = null
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showRedirectLoader, setShowRedirectLoader] = useState(false);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      
      if (redirectUrl && showLoader) {
        // Start countdown immediately
        setShowRedirectLoader(true);
        setCountdown(3);
      } else if (autoClose) {
        // Auto close after specified delay for regular notifications
        const timer = setTimeout(() => {
          setIsVisible(false);
          setTimeout(() => {
            onClose();
          }, 400); // Wait for fade out animation
        }, autoCloseDelay);
        return () => clearTimeout(timer);
      }
    }
  }, [show, onClose, redirectUrl, showLoader, autoClose, autoCloseDelay]);

  // Countdown effect
  useEffect(() => {
    if (showRedirectLoader && countdown > 0) {
      const countdownTimer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      
      return () => clearTimeout(countdownTimer);
    } else if (showRedirectLoader && countdown === 0) {
      if (redirectUrl && typeof redirectUrl === 'string') {
        if (redirectUrl.startsWith('http://') || redirectUrl.startsWith('https://')) {
          // External URL - open in new tab
          window.open(redirectUrl, '_blank');
          setIsVisible(false);
          setTimeout(() => {
            onClose();
          }, 400);
        } else {
          // Internal URL redirection
          window.location.href = redirectUrl;
        }
      }
    }
  }, [showRedirectLoader, countdown, redirectUrl, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 400); // Wait for fade out animation
  };

  if (!show) return null;

  return (
    <div className={`notification-overlay ${isVisible ? 'show' : ''}`}>
      <div className={`notification-popup ${type} ${isVisible ? 'show' : ''}`}>
        <button className="notification-close-btn" onClick={handleClose}>✕</button>
        <div className="notification-content">
          <div className="notification-icon" style={customIcon ? { fontSize: '64px', lineHeight: 1 } : {}}>
            {customIcon || (type === 'success' ? '✓' : type === 'info' ? 'ℹ' : type === 'warning' ? '⚠' : '✕')}
          </div>
          <div className="notification-message">
            {message}
          </div>
          {customButton || (showRedirectLoader && redirectUrl && (
            <div className="notification-loader">
              <div className="countdown-container">
                <div className="countdown-number">{countdown}</div>
              </div>
              <div className="loader-text">Redirecting...</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;


